import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';


@Component({
  selector: 'ngx-modal-add-ingresos-gastos-actividades',
  templateUrl: './modal-add-ingresos-gastos-actividades.component.html',
  styleUrls: ['./modal-add-ingresos-gastos-actividades.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService]
})



export class ModalAddIngresosGastosActividadesComponent implements OnInit {
  private valorSelect: number;
  constructor(private router:Router, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalAddIngresosGastosActividadesComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService,private _http : PeticionesHttpBackEndService) { 
      this.datosEntidadAct = data;
  }

  TipologiasSelect: any;
  tokenRequest: any;
  datosEntidadAct: any;
  DeshabilitaBoton: Boolean;
  tipo:any;
  tipoIngreso:any;
  cantidad:any = "";
  concepto:any="";
  nombre:any;
  apellidos:any;
  nombreActividad:any;
  JsonIngreso:any;
  actividadId:any;
  entidadId:any;
  actividadEntidadTipoId:any;
  listTipoIngreso:any = [];
  resultTipoIngreso:any;
  ingresoActivo = false;
  listTipoPago:any = [];
  activarTipo = false;
  tipoPago:any;
  conceptoCopia:any;
  faltasAsistencias:any="";
  activarFaltasAsistencias = false;
  resultAsistencias:any;
  flipped:any = false;
  toggleView() { 
    this.flipped = !this.flipped;
   }
  ngOnInit() {
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.tokenRequest = token;
        this.nombre = this.datosEntidadAct.contenido.Nombre;
        this.apellidos = this.datosEntidadAct.contenido.Apellidos;
        this.nombreActividad = this.datosEntidadAct.contenido.NombreActividad;
        this.actividadId = this.datosEntidadAct.contenido.ActividadId;
        this.entidadId = this.datosEntidadAct.contenido.EntidadId;
        this.actividadEntidadTipoId = this.datosEntidadAct.contenido.ActividadEntidadTipoId;
        if(this.actividadEntidadTipoId == 3){
          this.activarFaltasAsistencias = true;
        }else{
          this.activarFaltasAsistencias = false;
        }
        this._http.getGenerico("v1/tipoIngreso").subscribe(
          result => {
            this.resultTipoIngreso = result;
            this.resultTipoIngreso.TipoIngreso.forEach(element => {
              if(element._es_ingreso){
               this.listTipoIngreso.push(element);
              }else{
                this.listTipoPago.push(element);
              }
            });
      
            },
          error => {
            this.utilidades.notificationWarning("Aviso","Error intentando cargar los tipos de gastos/ingresos","top-left");
          }
        );
      }
    }); 
  }


  

  save(){
    if(this.tipoPago != undefined || this.tipoIngreso != undefined){

    if(!this.ingresoActivo){
      this.JsonIngreso = {ActividadId:this.actividadId,Concepto:this.concepto,EntidadId:this.entidadId,ActividadEntidadTipoId:this.actividadEntidadTipoId,Cantidad:this.cantidad,EsIngreso:this.tipo,TipoGasto:this.tipoPago,TipoIngreso:null};
    }else{
      this.JsonIngreso = {ActividadId:this.actividadId,Concepto:this.concepto,EntidadId:this.entidadId,ActividadEntidadTipoId:this.actividadEntidadTipoId,Cantidad:this.cantidad,EsIngreso:this.tipo,TipoIngreso:this.tipoIngreso};
    }
    
    this._PeticionesHttpBackEndService.postGeneralConParametro("nuevoGasto",{Data:this.JsonIngreso}).subscribe( 

      result => {
        this.utilidades.notificationSuccess("Éxito","Ingreso añadido correctamente","top-left");
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al añadir el ingreso"+"","top-left");
      }
    );      
      this.dialogRef.close();
    }else {
      this.utilidades.notificationWarning("Aviso",""+"Seleccione el tipo"+"","top-left");
    }
  }
  saveAsistencias(){
    if(this.faltasAsistencias != "" || this.faltasAsistencias != undefined){
      this.JsonIngreso = {ActividadId:this.actividadId,EntidadId:this.entidadId,FaltasAsistencias:this.faltasAsistencias,ActividadEntidadTipoId:this.actividadEntidadTipoId};
      this._PeticionesHttpBackEndService.postGeneralConParametro("anadirFaltasAsistencias",{Data:this.JsonIngreso}).subscribe( 
        result => {
          this.resultAsistencias = result;
          if(this.resultAsistencias.Code == 200){
          this.utilidades.notificationSuccess("Éxito",this.resultAsistencias.Mensaje,"top-left");
          }else{
            this.utilidades.notificationWarning("Error",this.resultAsistencias.Mensaje,"top-left");
          }
        },
        error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al añadir el ingreso"+"","top-left");
        }
      );      
        this.dialogRef.close();
    }else{
      this.utilidades.notificationWarning("Aviso","Debe rellenar el campo","top-left");
    }
  }

  close(){
    this.dialogRef.close();
  }

  cambioSelect(event){
    this.activarTipo = true;
    if(event == 0){
      this.ingresoActivo = false;
      this.concepto ="Gastos ";
    }else{
      this.ingresoActivo = true;
      this.concepto ="Ingresos ";
    }
    this.conceptoCopia = this.concepto;
  }
  cambioTipo(event){
    this.concepto = this.conceptoCopia + this.resultTipoIngreso.TipoIngreso[event-1]._descripcion+" - ";
    
  }
}
